module.exports = __webpack_public_path__ + "img/chivas-logo-agepage.e4f8dff9.png";